import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { CheckCircle, DashCircle } from 'react-bootstrap-icons'
import ReportInfluencerPerformance from '../../../../../../models/ReportInfluencerPerformance'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

export default observer(function InfluencerPerformanceSelector({ influencerId, formProps }) {
  const readOnly = useReadOnly()
  const { values, setFieldValue } = formProps
  const [performanceRecord, setPerformanceRecord] = useState(null)

  useEffect(() => {
    if (influencerId) {
      const existingPerformance = values.report_influencer_performances_attributes.find(
        p => p.influencer_id === influencerId && !p._destroy
      )
      
      if (existingPerformance) {
        setPerformanceRecord(existingPerformance)
      } else {
        const newPerformance = new ReportInfluencerPerformance({
          influencer_id: influencerId,
          performance: null // Default to null for undetermined
        })
        
        setFieldValue('report_influencer_performances_attributes', [
          ...values.report_influencer_performances_attributes, 
          newPerformance
        ])
        
        setPerformanceRecord(newPerformance)
      }
    }
  }, [influencerId, values.report_influencer_performances_attributes, setFieldValue])

  const updatePerformance = (value) => {
    const index = values.report_influencer_performances_attributes.findIndex(
      p => p.influencer_id === influencerId && !p._destroy
    )
    
    if (index !== -1) {
      setFieldValue(`report_influencer_performances_attributes[${index}].performance`, value)
    } else {
      console.error("Performance record not found after creation")
    }
  }

  if (!performanceRecord) return null;

  return (
    <div>
        <div className="flex gap-4">
          <label className={`relative ${readOnly ? 'cursor-default' : 'cursor-pointer'} text-md px-3 py-2 font-medium border-1 rounded-md transition-all ${
            performanceRecord.performance === 'good' 
              ? 'border-2 border-rb-green bg-rb-soft-green text-rb-green' 
              : 'border-rb-widget-border text-rb-green'
          }`}>
            <input 
              type="radio"
              name={`performance_${influencerId}`}
              value="good"
              className="absolute opacity-0"
              checked={performanceRecord.performance === 'good'}
              disabled={readOnly}
              onChange={() => updatePerformance('good')}
            />
            <CheckCircle />
          </label>
          <label className={`relative ${readOnly ? 'cursor-default' : 'cursor-pointer'} text-md px-3 py-2 font-medium border-1 rounded-md transition-all ${
            performanceRecord.performance === 'adequate' 
              ? 'border-2 border-rb-green bg-rb-soft-green text-rb-black' 
              : 'border-rb-widget-border text-rb-black'
          }`}>
            <input
              type="radio" 
              name={`performance_${influencerId}`}
              value="adequate"
              className="absolute opacity-0"
              checked={performanceRecord.performance === 'adequate'}
              disabled={readOnly}
              onChange={() => updatePerformance('adequate')}
            />
            <DashCircle />
          </label>
        </div>
    </div>
  )
})